const $ = jQuery.noConflict();

const initPeopleManualBlocks = () => {
	const peopleManualObjects = [];
	const peopleManualBlocks = document.querySelectorAll(
		'.block-people-manual'
	);
	peopleManualBlocks.forEach((block) => {
		const cardsContainer = $('.block-people-manual__cards', block);
		const cards = $('.person-card', cardsContainer);

		peopleManualObjects.push({
			cardsContainer,
			cards,
			cardsTotal: cards.length,
			cardsPage: 1,
			cardsPerPage: 8,
			viewMoreButton: $('.block-people-manual__view-more', block),
		});
	});

	if (peopleManualObjects.length) {
		peopleManualObjects.forEach((block) => {
			// Disable Load More button on load if no more than 8 cards.
			if (block.cardsTotal <= 8) {
				block.viewMoreButton.prop('disabled', true);
				block.viewMoreButton.parent().addClass('disabled');
			}

			block.viewMoreButton.on('click', () => {
				if (block.cardsPage * block.cardsPerPage < block.cardsTotal) {
					$(
						'.person-card:nth-child(n+' +
							(block.cardsPage * block.cardsPerPage + 1) +
							'):lt(' +
							block.cardsPerPage +
							')',
						block.cardsContainer
					).addClass('active');

					block.cardsPage++;

					if (
						block.cardsPage * block.cardsPerPage >=
						block.cardsTotal
					) {
						block.viewMoreButton.prop('disabled', true);
						block.viewMoreButton.parent().removeClass('disabled');
					}
				}
			});
		});
	}
};

const controller = {
	init() {
		initPeopleManualBlocks();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
